// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2fOj1","row":"styles_row__3t4xl"};